// Library Import
import {
  Alert,
  AlertIcon,
  Button,
  Flex,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  VStack,
  Box,
  Heading,
  Text,
  useColorMode,
  useColorModeValue,
  AspectRatio,
  Icon,
} from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMail, FiLock } from "react-icons/fi";
import { Image } from "@chakra-ui/react";

// Local Imports
import { redSetToast } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import Toasts from "../../components/Toasts";
import { redSetAdminLogin } from "../../redux/slices/adminSlice";

const AdminLoginScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { colorMode, toggleColorMode } = useColorMode();

  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);

  const loginHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    if (
      userName === import.meta.env.VITE_ADMIN_ID &&
      password === import.meta.env.VITE_ADMIN_PASSWORD
    ) {
      dispatch(redSetAdminLogin());
      localStorage.setItem("adminLogin", JSON.stringify(true));
      navigate("/adminDash");
    } else {
      dispatch(redSetToast({ title: "Invalid credentials", status: "error" }));
    }

    setLoading(false);
  };

  return (
    <>
      <Toasts />
      <Flex
        position="relative"
        minH="100vh"
        w="100%"
        direction="column"
        align="center"
        bg={useColorModeValue("white", "gray.800")}
        overflow="hidden"
      >
        <Flex
          position="absolute"
          inset={0}
          bg={useColorModeValue(
            "radial-gradient(#9B9B9B, 1.3px, transparent 1px)",
            "radial-gradient(#666666, 1.3px, transparent 1px)"
          )}
          backgroundSize="25px 25px"
          opacity={0.4}
          sx={{
            maskImage:
              "radial-gradient(ellipse 50% 50% at 50% 50%, #000 70%, transparent 100%)",
            WebkitMaskImage:
              "radial-gradient(ellipse 50% 50% at 50% 50%, #000 70%, transparent 100%)",
          }}
        />

        {/* Centered Navbar */}
        <Flex
          position="fixed"
          top={0}
          left={0}
          right={0}
          zIndex={20}
          direction="column"
          bg={useColorModeValue(
            "rgba(255, 255, 255, 0.9)",
            "rgba(26, 32, 44, 0.9)"
          )}
          backdropFilter="blur(10px)"
        >
          <Flex justify="center" align="center" py={2} px={8}>
            <Flex w="100%" maxW="1400px" justify="space-between" align="center">
              <Box
                bg={useColorModeValue("transparent", "white")}
                p="6px"
                borderRadius="3xl"
                boxShadow={useColorModeValue("none", "sm")}
                transition="all 0.2s"
                border="1px solid"
                borderColor={useColorModeValue("gray.200", "gray.200")}
              >
                <Image
                  src="/src/assets/CCLOGOFULL.png"
                  alt="Campus Credentialss"
                  height="40px"
                />
              </Box>
              <Button
                onClick={toggleColorMode}
                size="md"
                variant="ghost"
                _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
              >
                {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
              </Button>
            </Flex>
          </Flex>
          <Box
            borderBottom="1px solid"
            borderColor={useColorModeValue("gray.200", "gray.700")}
            w="100%"
          />
        </Flex>

        <Box mt="100px" w={{ base: "90%", md: "600px" }} zIndex={1}>
          <Box
            bg={useColorModeValue("white", "gray.700")}
            p={8}
            borderRadius="xl"
            boxShadow={useColorModeValue(
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              "0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.2)"
            )}
            border="1px solid"
            borderColor={useColorModeValue("gray.100", "gray.600")}
          >
            <VStack spacing={6}>
              <VStack spacing={2} textAlign="center">
                <Heading
                  size="lg"
                  fontWeight="bold"
                  color={useColorModeValue("gray.800", "white")}
                >
                  Admin Portal
                </Heading>
                <Text
                  color={useColorModeValue("gray.600", "gray.400")}
                  fontSize="md"
                >
                  Sign in to access admin dashboard
                </Text>
              </VStack>

              <form onSubmit={loginHandler} style={{ width: "100%" }}>
                <VStack spacing={4} width="100%">
                  <InputGroup>
                    <InputLeftElement pointerEvents="none">
                      <FiMail color="gray" />
                    </InputLeftElement>
                    <Input
                      type="text"
                      placeholder="Admin Email"
                      size="lg"
                      onChange={(e) => setUserName(e.target.value)}
                      _focus={{
                        borderColor: "blue.500",
                        boxShadow: "0 0 0 1px #3182ce",
                      }}
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputLeftElement pointerEvents="none">
                      <FiLock color="gray" />
                    </InputLeftElement>
                    <Input
                      type="password"
                      placeholder="Password"
                      size="lg"
                      onChange={(e) => setPassword(e.target.value)}
                      _focus={{
                        borderColor: "blue.500",
                        boxShadow: "0 0 0 1px #3182ce",
                      }}
                    />
                  </InputGroup>

                  <Button
                    type="submit"
                    colorScheme="blue"
                    size="lg"
                    width="100%"
                    isLoading={loading}
                    loadingText="Signing in"
                    _hover={{ transform: "translateY(-1px)" }}
                    transition="all 0.2s"
                  >
                    Sign In
                  </Button>
                </VStack>
              </form>
            </VStack>
          </Box>
        </Box>

        {/* Centered Footer */}
        <Flex
          position="fixed"
          bottom={0}
          w="100%"
          py={4}
          px={8}
          borderTop="1px solid"
          borderColor={useColorModeValue("gray.200", "gray.700")}
          bg={useColorModeValue(
            "rgba(255, 255, 255, 0.9)",
            "rgba(26, 32, 44, 0.9)"
          )}
          backdropFilter="blur(10px)"
          justify="center"
          align="center"
          zIndex={1}
        >
          <Box w="100%" maxW="1400px" textAlign="center">
            <Text
              color={useColorModeValue("gray.600", "gray.400")}
              fontSize="sm"
            >
              © {new Date().getFullYear()} Campus Credentials. All Rights
              Reserved
            </Text>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default AdminLoginScreen;
